import * as React from 'react';
import styles from './index.less';
import FModal from '@/components/FModal';
import { QRCode } from 'antd';
import { FUtil } from '@freelog/tools-lib';
import img_wechat from './wechat@2x.png';
import img_weixin from '@/assets/weixin.jpg';

interface FWeiXinShareProps {
  configs: {
    title: string;
    desc: string;
    link: string;
    imgUrl: string;
  };

  onClose?: () => void;
}

function FWeiXinShare({ configs, onClose }: FWeiXinShareProps) {
  const [$isShowWechatShareModal, set$isShowWechatShareModal, get$isShowWechatShareModal] =
    FUtil.Hook.useGetState<boolean>(true);

  return (
    <FModal
      open={$isShowWechatShareModal}
      width={320}
      onCancel={() => {
        set$isShowWechatShareModal(false);
      }}
      centered={true}
      afterClose={() => {
        onClose?.();
      }}
    >
      <div style={{ height: 50 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <img src={img_wechat} style={{ width: 26 }} alt='' />
        <div
          style={{
            fontWeight: 400,
            fontSize: 16,
            color: '#222222',
            lineHeight: '22px',
          }}
        >
          扫码分享至微信
        </div>
      </div>
      <div style={{ height: 30 }} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <QRCode
          style={{ padding: 0, borderRadius: 0, border: 'none' }}
          value={
            'https://www.freelog.cn' +
            FUtil.LinkTo.wxShare({
              title: encodeURIComponent(configs.title),
              desc: encodeURIComponent((configs.desc || ' ').slice(0, 80)),
              link: encodeURIComponent(self.location.href),
              imgUrl: encodeURIComponent(configs.imgUrl),
            })
          }
          // icon={img_weixin}
          bgColor={'#fff'}
          color={'#222'}
          size={220}
        />
      </div>
      <div style={{ height: 50 }} />
    </FModal>
  );
}

export default FWeiXinShare;
